function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#231f20",
  d: "M0 0h28.35v28.35H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.76 24.51h-4.69L18 20.86h-7.68l-1.09 3.65H4.59l6.79-20.68h5.54zm-7.26-8l-2.37-8.2-2.36 8.21z",
  fill: "#fff"
})));

function SvgRatingA(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28.35 28.35"
  }, props), _ref);
}

export default SvgRatingA;